import { render, staticRenderFns } from "./CodeRenderer.vue?vue&type=template&id=e16e15b0&scoped=true&lang=pug&"
import script from "./CodeRenderer.vue?vue&type=script&lang=ts&"
export * from "./CodeRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./CodeRenderer.vue?vue&type=style&index=0&id=e16e15b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16e15b0",
  null
  
)

export default component.exports